import Modal from "../../../../molecules/Modal"
import WarningIcon from "../../../../../assets/icons/Warning"
import Button from "../../../../atoms/Button"
import styles from "./index.module.scss"
import intl from "react-intl-universal"
import { Table } from "../../../../molecules/Table"

export const ModalAnalyteLinkedSameLevel = ({ title, description, onCancel, data }) => {
  return (
    <Modal isOpen={true} size="lg">
      <Modal.Header
        style={{
          justifyContent: "center",
          padding: "0.5rem",
        }}
        onClose={onCancel}
      >
        <h1 className={styles.titleModal}>{title}</h1>
      </Modal.Header>

      <div className={styles.flexCenter}>
        <WarningIcon className={styles.icon} />
        <p>{description}</p>

        <Table
          bEdit={false}
          cursorNormal
          thead={[
            intl.get("ciq.name_exame_analyte"),
            intl.get("ciq.name_control"),
            intl.get("ciq.level_control"),
          ]}
          tbodyArray={data}
        />
      </div>
      <div className={styles.containerButton}>
        <Button type="button" variant="outline" onClick={onCancel}>
          {intl.get("cap_close")}
        </Button>
      </div>
    </Modal>
  )
}
